import { useTranslation } from '@framework/i18n';
import { Select, Typography } from 'antd';
import { ExportFileField } from './ExportFileTypes';
import { useExportFileFieldSelectOptions } from './useExportFileFieldSelectOptions';

export interface IExportFileMultipleSemanticFieldsSelectProps {
  fields: ExportFileField[] | null | undefined;
  isLoading: boolean;
  selected?: string[];
  onSelect?: (fields: string[]) => void;
}

/**
 * Seleziona i campi semantici multipli da esportare come righe
 */
export function ExportFileMultipleSemanticFieldsSelect(
  props: IExportFileMultipleSemanticFieldsSelectProps,
) {
  const { fields, isLoading, onSelect, selected } = props;

  const { t } = useTranslation();
  const options = useExportFileFieldSelectOptions(fields);

  return (
    <>
      <Typography.Paragraph>
        {t(
          'export--multiple-semantic-field-select.select-multiple-semantic-fields-to-export-title',
          'Seleziona i campi semantici multipli da esportare. Verrà aggiunta una riga per ogni campo semantico multiplo.',
        )}
      </Typography.Paragraph>
      <Select
        mode={'multiple'}
        style={{ width: '100%' }}
        placeholder={t(
          'export--multiple-semantic-field-select.select--multiple-semantic-fields-to-export',
          'Seleziona i campi semantici multipli da esportare come righe',
        )}
        loading={isLoading}
        options={options}
        onChange={onSelect}
        defaultValue={selected}
        value={selected}
        optionFilterProp={'label'}
      />
    </>
  );
}
